export const KEBAB_CASE_PATTERN = /^[a-z0-9]+(-[a-z0-9]+)*$/;

export const isValidEventKey = (value: string): boolean => {
    if (!value || value.trim() === "") return true;
    return KEBAB_CASE_PATTERN.test(value.trim());
};
